import React from 'react'
import UserWorkPlaceForm from '../form/UserWorkPlaceForm'
import ResultItem from '../../../pack/form/result/ResultItem'
import { getDateAndTimeText } from '../../../../helpers/date/dateHelper'

const UserWorkPlaceVisibleData = ({ result }) => {
  return (
    <div>
        {
            result.workPlacePresence ?
                <div className='packResultBlock'>
                    <p className='packResultBlock__text'>Зараз Ви на робочому місці</p>
                    <div className='packResultBlock__list'>
                        <ResultItem
                            text='Місце фіксації'
                            // value={getWorkPlaceType({ type: result.type })}
                            // value={result && result.department ? result.department.typeName : ''}
                            value={result && result.department && result.department.type ? result.department.type.name : ''}
                        />
                        <ResultItem
                            // text='Назва (повна)'
                            text='Назва'
                            value={result && result.department ? result.department.name : ''}
                        />
                        {/* <ResultItem
                            text='Назва (коротка)'
                            value={result && result.department ? result.department.slug : ''}
                        /> */}
                        <ResultItem
                            text='Дата та час початку роботи'
                            value={result && result.workPlacePresence ? getDateAndTimeText(result.workPlacePresence.dateStart) : ''}
                        />
                    </div>
                    <br /><br />
                    <p className='packResultBlock__text'>Для завершення роботи відскануйте QR-код</p>
                    <UserWorkPlaceForm />
                </div>
            : 
                <UserWorkPlaceForm />
        }
    </div>
  )
}

export default UserWorkPlaceVisibleData